import { render, staticRenderFns } from "./course-user.vue?vue&type=template&id=3f2d4f93"
import script from "./course-user.vue?vue&type=script&lang=js"
export * from "./course-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports